module.exports = __webpack_public_path__ + "static/22-aerial-views-vii-436a2bcad063d9aa2e451b7e405caec6.jpeg";